import script from "./FavoriteVacancy.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteVacancy.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteVacancy.vue?vue&type=style&index=0&id=37f32f13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f32f13"]])

export default __exports__